module.exports = __webpack_public_path__ + "img/logo.a5c8a773.svg";